'use client';
import Heading from '@/components/shared/Heading';
import { HtmlBlock } from '@/components/ui/HtmlBlock';
import { ContentCenter } from '@/graphql/common/contentCenter/types';
import { cn } from '@/utils/mergeClassName';
import { onlyTextTags } from '@/utils/onlyTextTags';
import { ContentCenterCarousel } from '../ContentCenterAxa/ContentCenterCarousel';

type ContentsProps = {
  title: string;
  description: string;
  enableBackgroundColor?: boolean;
  items: ContentCenter;
};

export const Contents = ({
  title,
  description,
  items,
  enableBackgroundColor = false
}: ContentsProps) => {
  return (
    <section className={cn('w-full', enableBackgroundColor ? 'bg-grey-200' : 'bg-white')}>
      <div className="flex max-w-7xl flex-col gap-10 px-6 py-12 lg:p-20 2xl:mx-auto 2xl:px-0">
        <div className="flex w-full flex-1 flex-col gap-4 lg:max-w-[43.75rem] lg:gap-10">
          <Heading
            variant="h2"
            className="text-left font-publico text-2xl text-blue-500 lg:text-left lg:text-[40px] lg:leading-[48px] "
            asChild
          >
            <h2>{title}</h2>
          </Heading>
          <HtmlBlock
            html={onlyTextTags(description)}
            className="text-left text-lg text-grey-900 lg:text-left lg:text-xl"
          />
        </div>
      </div>
      <div className="w-full px-5 pb-12 lg:pb-0 lg:pl-20 ">
        <ContentCenterCarousel
          cards={items}
          onEnableBackground={() => true}
          hover
          className="lg:h-[25rem] lg:w-[36.625rem]"
        />
      </div>
    </section>
  );
};
